const monthlyOperations = ['1', '2', '3', '4', '+ de 5'];
const monthlyAmount = [
  '$100,000 a $500,000',
  '$500,001 a $1,000,000',
  '$1,000,001 a $2,000,000',
  '$2,000,001 a $5,000,000',
  'Más de $5,000,000'
];

export default [monthlyAmount, monthlyOperations];
